import theme from 'config/theme';

export const STATUS_BACKGROUND_COLORS = {
  Pending: theme.palette.fukshias.fukshia200,
  'In Progress': theme.palette.violets.violet200,
  Done: theme.palette.greens.green200,
};
export const STATUS_COLORS = {
  Pending: theme.palette.fukshias.fukshia900,
  'In Progress': theme.palette.violets.violets900,
  Done: theme.palette.greens.line900,
};

export const CONNECT_MAIL_TO_ENTITY_ERROR =
  'Please connect this email to an entity before replying or forwarding.';
